import { Skeleton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { theme } from '../../../../../modules/App/Providers/Theme/theme'

type GridArea = 'type' | 'day' | 'time' | 'ctas'

const SectionSkeleton = ({ gridArea }: { gridArea: GridArea }) => (
  <div style={{ gridArea }}>
    <Skeleton width="100%" height="3rem" />
    <Skeleton variant="rectangular" width="100%" height={300} />
  </div>
)

const Container = styled('div')`
  align-items: start;
  display: grid;
  gap: 1rem;
  grid-template-areas:
    'type'
    '.'
    'day'
    '.'
    'time'
    'gap'
    'ctas';
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  @media (min-width: 769px) {
    gap: 1rem;
    grid-template-areas:
      'type .    day  .    time'
      'ctas ctas ctas ctas ctas';
    grid-template-columns: 1fr auto 1fr auto 1fr;
    grid-template-rows: auto auto;
  }
`

const VerticalRule = styled('div')`
  align-content: start;
  background-color: ${theme.palette.grey[200]};
  display: none;
  align-self: end;
  height: 1px;

  @media (min-width: 769px) {
    display: grid;
    height: 96%;
    place-items: center;
    width: 1px;
  }
`
const Gap = styled('div')`
  height: 1rem;
  width: 100%;

  @media (min-width: 769px) {
    display: none;
  }
`

export type { GridArea }
export { Container, Gap, SectionSkeleton, VerticalRule }
